import * as React from 'react';

import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { push, CallHistoryMethodAction } from 'connected-react-router';

import styled from 'styled-components';
import { getWidth } from '@components/styles';

import PricingCtrl from '@webapp/controllers/pricing';
import MotionOpacity from '@components/motion/motion-opacity';

import { Price } from '@common/types/price/price';
import { Product } from '@services/product/types/product';
import { CreateOrder, EmptyBasket } from '@webapp/store/orders/action-creators';
import {
  LabelOnboardingSelectPlan,
  StartLabelOnboarding,
} from '@webapp/store/record-labels/action-creators';
import { Translate } from 'react-localize-redux';

interface OnboardingPricingPageProps {
  className?: string;
}

interface StateProps {
  goToCreateRecordLabel: () => CallHistoryMethodAction;
  goToCreateArtist: () => CallHistoryMethodAction;
  selectPlan: (product: Product, price: Price) => void;
  emptyBasket: () => EmptyBasket;
  startLabelOnboarding: () => StartLabelOnboarding;
  onboardingSelectPlan: (
    product: Product,
    price: Price
  ) => LabelOnboardingSelectPlan;
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  goToCreateRecordLabel: () => dispatch(push('/onboarding/label')),
  goToCreateArtist: () => dispatch(push('/onboarding/artist')),
  emptyBasket: () => dispatch(new EmptyBasket()),
  startLabelOnboarding: () => dispatch(new StartLabelOnboarding()),
  selectPlan: (product: Product, price: Price) =>
    dispatch(
      new CreateOrder({
        product,
        price,
        quantity: 1,
      })
    ),
  onboardingSelectPlan: (product: Product, price: Price) =>
    dispatch(new LabelOnboardingSelectPlan(product, price)),
});

export const OnboardingPricingPage = (
  props: OnboardingPricingPageProps & StateProps
) => {
  const { emptyBasket } = props;

  React.useEffect(() => {
    emptyBasket();
  }, [emptyBasket]);

  const handleSelection = (product: Product, price: Price) => {
    const isLabel = product.category === 'PLAN_RECORD_LABEL';

    // Label Onboarding
    if (isLabel) {
      props.startLabelOnboarding();
      props.onboardingSelectPlan(product, price);
      return props.goToCreateRecordLabel();
    }

    // Artist onboarding
    props.selectPlan(product, price);
    return props.goToCreateArtist();
  };

  return (
    <MotionOpacity className={props.className}>
      <PricingContainer>
        <PricingCtrl
          categories={['PLAN', 'PLAN_RECORD_LABEL']}
          omit={['plan_record_label_team']}
          onSelection={handleSelection}
          buttonLabel={<Translate id="ONBOARDING.PRICING.RECORD_LABEL" />}
          currentSubscription={undefined}
        />
      </PricingContainer>
    </MotionOpacity>
  );
};

export default connect(
  null,
  mapDispatchToProps
)(styled(OnboardingPricingPage)`
  position: relative;
  margin-top: 24px;

  ${({ theme }) => `@media screen and ${theme.device.laptopS}`} {
    padding-bottom: 50px;
  }
`);

const PricingContainer = styled.div`
  margin: auto;
  max-width: ${getWidth(6)};

  ${({ theme }) => `@media screen and ${theme.device.tablet}`} {
    max-width: ${getWidth(8)};
  }
`;
